import { render, staticRenderFns } from "./heroes.vue?vue&type=template&id=41672736&scoped=true&"
import script from "./heroes.vue?vue&type=script&lang=js&"
export * from "./heroes.vue?vue&type=script&lang=js&"
import style0 from "./heroes.vue?vue&type=style&index=0&id=41672736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41672736",
  null
  
)

export default component.exports